export default "__VITE_ASSET__caf1de27__"